import { ChevronRightIcon, KeyIcon } from "@heroicons/react/24/outline";
import { Trans, useLingui } from "@lingui/react/macro";
import { useRouter } from "router2";

import { usePasskey } from "~/hook/domain/usePasskey.ts";
import { WebLayout } from "~/ui/layout/WebLayout.tsx";
import { useAuthNavigator, useUser } from "~/ui/provider/Auth.tsx";
import { useNotification } from "~/ui/provider/Notification.tsx";

export const WebHome = () => {
  useAuthNavigator({ goToApp: "/web/search" });
  const pushNotification = useNotification();
  const { t } = useLingui();
  const { push } = useRouter();
  const { isLoggedIn } = useUser();
  const { authenticate, canAuthenticate } = usePasskey();

  const showPasskeyButton = canAuthenticate();

  return (
    <WebLayout>
      <div className="flex flex-col items-center pt-6">
        <img
          alt={t`요기콕콕! 로고`}
          className="size-44 rounded-3xl border border-zinc-200/80 object-cover shadow-lg dark:border-zinc-800"
          src="/asset/icon.jpg"
        />

        <div className="mt-16 flex w-full max-w-md flex-col gap-4">
          {!isLoggedIn ? (
            <>
              {showPasskeyButton && (
                <>
                  <button
                    className="flex items-center gap-4 rounded-2xl bg-black p-4 duration-300 active:opacity-60 disabled:opacity-60 dark:bg-zinc-800"
                    data-testid="패스키로 로그인 버튼"
                    onClick={() => {
                      authenticate().catch(() => {
                        pushNotification({ content: t`다시 시도해주세요.` });
                      });
                    }}
                    type="button"
                  >
                    <span className="text-zinc-100">
                      <KeyIcon className="size-6" />
                    </span>
                    <p className="flex-1 text-left text-white">
                      <Trans>Passkey로 시작하기</Trans>
                    </p>
                    <span className="text-zinc-500">
                      <ChevronRightIcon className="size-6" />
                    </span>
                  </button>
                  <button
                    className="rounded-2xl p-2 text-sm text-zinc-400 duration-300 active:opacity-60"
                    data-testid="패스키가 있지만, 패스키 없이 로그인 버튼"
                    onClick={() => {
                      push({ pathname: "/web/sign-in" });
                    }}
                    type="button"
                  >
                    <Trans>아이디로 로그인</Trans>
                  </button>
                </>
              )}
              {!showPasskeyButton && (
                <button
                  className="flex items-center gap-4 rounded-2xl bg-black p-4 duration-300 active:opacity-60 disabled:opacity-60 dark:bg-zinc-800"
                  data-testid="패스키 없이 로그인 버튼"
                  onClick={() => {
                    push({ pathname: "/web/sign-in" });
                  }}
                  type="button"
                >
                  <p className="flex-1 pl-2 text-left text-white">
                    <Trans>아이디로 로그인</Trans>
                  </p>
                  <span className="text-zinc-500">
                    <ChevronRightIcon className="size-6" />
                  </span>
                </button>
              )}
            </>
          ) : (
            <button
              className="flex items-center justify-between rounded-2xl bg-black p-4 text-white duration-300 active:opacity-60 dark:bg-zinc-800"
              onClick={() => {
                push({ pathname: "/web/search" });
              }}
              type="button"
            >
              <span className="pl-2 font-medium">
                <Trans>콕 찌르기로 이동</Trans>
              </span>
              <span>👉</span>
            </button>
          )}
        </div>
      </div>
    </WebLayout>
  );
};
